import { Fragment, useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useComponentsContext } from "../../../ContextProvider";
import "../../../../assets/css/coupon-menu.scss";

const CouponPage = () => {
  const navigate = useNavigate();
  useEffect(() => {
    if (location.pathname === "/user/coupon") {
      navigate("couponMng");
    }
  }, [location.pathname]);

  return (
    <Fragment>
      <Outlet />
    </Fragment>
  );
};

export default CouponPage;
